import { formatErrorMessage } from '.';

class NotImplementedMenuTypeError extends Error {
    constructor(type) {
        super(formatErrorMessage(`"${type}" is not supported. Please check menu type.`));
        Error.captureStackTrace(this, NotImplementedMenuTypeError);
        this.name = 'NotImplementedMenuTypeError';
        this.type = type;
    }
}

export default NotImplementedMenuTypeError;
